import moment from "moment";
import React, { Fragment, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import Select, { components } from "react-select";
import { Button, Card, CardBody, Col, Container, FormGroup, Input, Row, Label } from "reactstrap";
import Breadcrumbs from "../../../layout/breadcrumb";
import CommonDataTable from "../../../share-components/table/commonDataTable";
import withReducer from "../../../store/withReducer";
import partnerPromotionReducer from "../store";
import ButtonLoader from "../../../share-components/ui/buttonLoader";
import DateRangePickerDefault from "../../../share-components/ui/DateRangePickerDefault";
import ApprovalModal from "./content/approvalModal";
import DeclineModal from "./content/declineModal";

import {
  getDifferenceDiscount,
  getPartnerPromotionSettings,
  setPartnerPromotionSettings,
  exportDifferenceDiscountReport,
  approveDiffDiscount,
  declineDiffDiscount,
} from "../store/partnerPromotionSlice";


function PartnersPromotions() {
  const dispatch = useDispatch();
  const history = useHistory();
  const [timer, setTimer] = useState(null);
  const [isDownloadReport, isSetDownloadReport] = useState(false);
  const partnerPromotionState = useSelector(({ partnerPromotion }) => partnerPromotion.partnerPromotion);
  const allSettings = useSelector(({ partnerPromotion }) => partnerPromotion.partnerPromotion?.settings);
  const [selectedRows, setSelectedRows] = useState([]);
  const [tableItems, setTableItems] = useState([]);

  const isValidDate = (d) => d !== null && d !== undefined && moment(d).isValid();

  const statusItems = [
    { id: 0, name: 'Pending' },
    { id: 1, name: 'Approved' },
    { id: 2, name: 'Declined' },
  ];

  const [tableLoading, setTableLoading] = useState(false);
  const [buttonDisabled, setButtonDisabled] = useState(false);
  const [approveBtnLoading, setApproveBtnLoading] = useState(false);
  const [declineBtnLoading, setDeclineBtnLoading] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [isOpenDecline, setIsOpenDecline] = useState(false);
  const [selectedReason, setSelectedReason] = useState(null);

  const [promotionDateRange, setPromotionDateRange] = useState([null, null]);
  const [promotionStartDate, promotionEndDate] = promotionDateRange;

  const [orderDateRange, setOrderDateRange] = useState([null, null]);
  const [orderStartDate, orderEndDate] = orderDateRange;

  const [filterPartner, setFilterPartner] = useState(null);
  const [filterStatus, setFilterStatus] = useState({ id: 0, name: 'Pending' });
  const [filterSKU, setFilterSKU] = useState('');
  const [filterOrderNo, setFilterOrderNo] = useState('');

  const [lastFillters, setLastFillters] = useState(null);
  const [filters, setFilters] = useState({
    page: 1,
    pageSize: 10,
    // set initial dates to null if not provided
    start_date: isValidDate(promotionStartDate) ? moment(promotionStartDate).format("YYYY-MM-DD") : null,
    end_date: isValidDate(promotionEndDate) ? moment(promotionEndDate).format("YYYY-MM-DD") : null,
    order_startdate: isValidDate(orderStartDate) ? moment(orderStartDate).format("YYYY-MM-DD") : null,
    order_enddate: isValidDate(orderEndDate) ? moment(orderEndDate).format("YYYY-MM-DD") : null,
    // Add new filter properties
    partner: filterPartner ? filterStatus.id : null,
    sku: filterSKU ?? null,
    order_no: filterOrderNo ?? null,
    status: filterStatus ? filterStatus.id : null,
    draw: 1,
  });

  useEffect(() => {
    dispatch(getPartnerPromotionSettings()).then((res) => {
      dispatch(setPartnerPromotionSettings(res.payload));
    });
  }, [dispatch]);

  const mapResponseToTable = (response) => {
    return response.map((res, index) => {
      let result = {
        ...res,
        isChecked: false,
      };
      return result;
    });
  };

  const getData = () => {
    if (JSON.stringify(filters) == JSON.stringify(lastFillters)) return;

    setLastFillters(filters);
    setTableLoading(true);

    dispatch(getDifferenceDiscount(filters)).then(res => {
      let items = [...mapResponseToTable(res.payload)];
      setSelectedRows([]);
      setTableItems(items);
      setTableLoading(false);
      setButtonDisabled(false);
      setApproveBtnLoading(false);
      setDeclineBtnLoading(false);
      setIsOpen(false);
    })
  };

  useEffect(() => {
    getData();
  }, [dispatch, filters]);

  const dataMenu = [
    {
      type: 1,
      text: "Partners Promotions",
      link: "/product/partners-promotions",
    },
    {
      type: 0,
      text: "Difference Discount",
    },
  ];

  const eventExport = () => {
    if (isDownloadReport) {
      return;
    }
    isSetDownloadReport(true);
    dispatch(exportDifferenceDiscountReport(filters)).then((res) => {
      const link = document.createElement("a");
      link.href = res.payload;
      link.setAttribute("download", "");
      document.body.appendChild(link);
      link.click();
      link.remove();
      isSetDownloadReport(false);
    });
  };

  // Function to update a specific row's data
  const updateRowData = (id, newData) => {
    const updatedData = tableItems.map((row) => {
      return row.id === id ? { ...row, ...newData } : { ...row };
    });
    setTableItems(updatedData);

    // Update for seleted data
    const updatedSeletedData = updatedData.filter((row) => {
      return row.isChecked == true;
    });
    setSelectedRows(updatedSeletedData);
  };

  const allCheckBoxChange = (isChecked) => {
    tableItems.forEach(function (item) {
      item.isChecked = isChecked;

      updateRowData(item.id, item);
    });
  }

  const tableColumns = [
    {
      name: <input onChange={(e) => {
        allCheckBoxChange(e.target.checked);
      }} type={"checkbox"} />,
      cell: (row) => {
        return (
          <input onChange={(e) => {
            row.isChecked = e.target.checked;
            updateRowData(row.id, row);
          }} checked={row.isChecked} type={"checkbox"} />
        );
      },
      ignoreRowClick: true,
      allowOverflow: true,
      sortable: false,
      center: true,
      width: '80px'
    },
    {
      name: "Order Name",
      selector: (row) => row.order_name,
      sortable: true,
      center: false,
    },
    {
      name: "SKU",
      sortable: true,
      center: false,
      selector: (row) => row.product_sku,
    },
    {
      name: "Partner Name",
      selector: (row) => row.partner_name,
      sortable: true,
      center: false,
    },
    {
      name: "Product Name",
      sortable: true,
      center: false,
      selector: (row) => row.product_name,
    },
    {
      name: "Quantity",
      selector: (row) => row.quantity,
      sortable: true,
      center: true,
    },
    {
      name: "Status",
      selector: (row) => row.status,
      sortable: true,
      center: true,
    },
    {
      name: "Actual Price",
      selector: (row) => row.actual_price,
      sortable: true,
      right: true,
    },
    {
      name: "Actual Sale Price",
      selector: (row) => row.actual_sale_price,
      sortable: true,
      right: true,
    },
    {
      name: "Sale Price",
      selector: (row) => row.sale_price,
      sortable: true,
      right: true,
    },
    {
      name: "Total Order Amount",
      selector: (row) => row.total_order_amount,
      sortable: true,
      right: true,
    },
  ];

  const onClickApprove = () => {    
    setButtonDisabled(true);
    setApproveBtnLoading(true);
    const orderItemIds = selectedRows.map(function (item) {
      return item.id;
    });
    dispatch(approveDiffDiscount({ ids: orderItemIds, reason_id: selectedReason })).then(response => {
      setFilters({ ...filters, draw: filters.draw + 1});
    });
  }

  const onClickDecline = () => {
    setButtonDisabled(true);
    setDeclineBtnLoading(true);
    const orderItemIds = selectedRows.map(function (item) {
      return item.id;
    });

    dispatch(declineDiffDiscount({ ids: orderItemIds, reason_id: selectedReason })).then(response => {
      setFilters({ ...filters, draw: filters.draw + 1});
    });
  }

  const onPageSizeChange = (newPageSize) => {
    setFilters(prev => ({
      ...prev,
      page: 1,
      pageSize: newPageSize === 'All' ? partnerPromotionState.differenceDiscount.totalRow : newPageSize
    }));
  }

  const onPageChange = (e) => {
    setFilters({ ...filters, page: e })
  }

  useEffect(() => {
    setFilters(prev => ({
      ...prev,
      start_date: isValidDate(promotionStartDate) ? moment(promotionStartDate).format("YYYY-MM-DD") : null,
      end_date: isValidDate(promotionEndDate) ? moment(promotionEndDate).format("YYYY-MM-DD") : null,
    }));
  }, [promotionStartDate, promotionEndDate]);

  useEffect(() => {
    setFilters(prev => ({
      ...prev,
      order_startdate: isValidDate(orderStartDate) ? moment(orderStartDate).format("YYYY-MM-DD") : null,
      order_enddate: isValidDate(orderEndDate) ? moment(orderEndDate).format("YYYY-MM-DD") : null,
    }));
  }, [orderStartDate, orderEndDate]);

  // Handle individual filters changes
  const handleFilterChange = (key, value) => {
    setFilters(prev => ({
      ...prev,
      [key]: value,
      page: 1, // Reset to first page when filters change
    }));
  };

  const handleTextInputChange = (key, value) => {
    clearTimeout(timer);
    const newTimer = setTimeout(() => {
      setFilters(prev => ({
        ...prev,
        [key]: value ?? null,
        page: 1, // Reset to first page when filters change
      }));
    }, 500);
    setTimer(newTimer)
  };

  // Clear all filters
  const clearFilters = () => {
    setFilters(prev => ({
      ...prev,
      page: 1,
      // set initial dates to null if not provided
      start_date: null,
      end_date: null,
      order_startdate: null,
      order_enddate: null,
      // Add new filter properties
      partner: null,
      sku: filterSKU ?? null,
      order_no: filterOrderNo ?? null,
      status: null,
      draw: filters.draw + 1,
    }));
    setPromotionDateRange([null, null]);
    setOrderDateRange([null, null]);
    setFilterPartner(null);
    setFilterStatus(null);
    setFilterSKU('');
    setFilterOrderNo('');
  };

  return (
    <Fragment>
      <Breadcrumbs title="Difference Discount" data={dataMenu} />
      <Container fluid={true}>
        {/* New Filters Card */}
        <Card>
          <CardBody className="p-3">
            <Row>
              <Col md="12">
                <div className="d-flex justify-content-between align-items-center mb-3">
                  <h6 className="mb-0">Filters</h6>
                  <div>
                    <button type="button" onClick={eventExport} className="btn btn-sm btn-dark mr-2" disabled={isDownloadReport}>
                      <i className={isDownloadReport ? "fa fa-spinner fa-spin mr-1" : "fa fa-download mr-1"}></i> Export
                    </button>
                    <Button className="float-right" color="secondary" size="sm" onClick={clearFilters}>
                      Clear Filters
                    </Button>
                  </div>
                </div>
              </Col>
            </Row>

            <Row>
              <Col md="">
                <FormGroup>
                  <Label>Promotions Date</Label>
                  <DateRangePickerDefault
                    placeholder="Search promotion date range"
                    dateRange={promotionDateRange}
                    dateRangeChange={(date) => {
                      if (date === null) {
                        setPromotionDateRange([null, null]);
                      } else {
                        setPromotionDateRange(date);
                      }
                    }}
                  />
                </FormGroup>
              </Col>
              <Col md="">
                <FormGroup>
                  <Label>Order Date</Label>
                  <DateRangePickerDefault
                    placeholder="Search order date range"
                    dateRange={orderDateRange}
                    dateRangeChange={(date) => {
                      if (date === null) {
                        setOrderDateRange([null, null]);
                      } else {
                        setOrderDateRange(date);
                      }
                    }}
                  />
                </FormGroup>
              </Col>
              <Col md="">
                <FormGroup>
                  <Label for="currency">Partner</Label>
                  <Select
                    className="select2-filter"
                    placeholder="Search by partner"
                    getOptionLabel={(option) => option.name}
                    getOptionValue={(option) => option.id}
                    value={filterPartner}
                    onChange={(e) => {
                      handleFilterChange('partner', e ? e.id : null);
                      setFilterPartner(e);
                    }}
                    components={{
                      IndicatorSeparator: () => null,
                      DropdownIndicator: (props) => {
                        return filterPartner ? null : <components.DropdownIndicator {...props} />;
                      }
                    }}
                    isClearable={true}
                    options={allSettings?.partners || []}
                  />
                </FormGroup>
              </Col>
            </Row>

            <Row>
              <Col md="">
                <FormGroup>
                  <Label for="filterSKU">SKU</Label>
                  <Input
                    type="text"
                    id="filterSKU"
                    placeholder="Search by SKU"
                    value={filterSKU}
                    onChange={(e) => {
                      handleTextInputChange('sku', e.target.value);
                      setFilterSKU(e.target.value);
                    }}
                  />
                </FormGroup>
              </Col>
              <Col md="">
                <FormGroup>
                  <Label for="filterOrderNo">Order Name</Label>
                  <Input
                    type="text"
                    id="filterOrderNo"
                    placeholder="Search by order name"
                    value={filterOrderNo}
                    onChange={(e) => {
                      handleTextInputChange('order_no', e.target.value);
                      setFilterOrderNo(e.target.value);
                    }}
                  />
                </FormGroup>
              </Col>
              <Col md="">
                <FormGroup>
                  <Label for="status">Status</Label>
                  <Select
                    className="select2-filter"
                    placeholder="Search by status"
                    getOptionLabel={(option) => option.name}
                    getOptionValue={(option) => option.id}
                    value={filterStatus}
                    onChange={(e) => {
                      handleFilterChange('status', e ? e.id : null);
                      setFilterStatus(e);
                    }}
                    components={{
                      IndicatorSeparator: () => null,
                      DropdownIndicator: (props) => {
                        return filterStatus ? null : <components.DropdownIndicator {...props} />;
                      }
                    }}
                    isClearable={true}
                    options={statusItems}
                  />
                </FormGroup>
              </Col>
            </Row>
          </CardBody>
        </Card>

        <Card>
          <CardBody className="p-3">
            <ButtonLoader 
              color="success" size="sm" className="mr-2 mb-2" btntext="Approve" 
              onClick={() => { setIsOpen(true); }} 
              disabled={buttonDisabled || !selectedRows.length} loading={approveBtnLoading} />

            <ButtonLoader 
              color="danger" size="sm" className="mr-2 mb-2" btntext="Decline" 
              onClick={() => { setIsOpenDecline(true); }} 
              disabled={buttonDisabled || !selectedRows.length} loading={declineBtnLoading} />

            <div className="table-responsive product-table">
              <CommonDataTable
                headerColumns={tableColumns}
                gridData={tableItems}
                progressPending={tableLoading}
                noAction
                paginationServer
                paginationTotalRows={partnerPromotionState.differenceDiscount.totalRow}
                currentPage={filters.page}
                perPage={filters.pageSize}
                paginationRowsPerPageOptions={[10, 25, 50, 100]}
                onChangeRowsPerPage={onPageSizeChange}
                onChangePage={onPageChange}
              />
            </div>
          </CardBody>
        </Card>
      </Container>

      {/* Approve Modal */}
      <ApprovalModal 
        isOpen={isOpen} 
        setIsOpen={setIsOpen}
        reasonItems={allSettings.discountApprovalReasons}
        onClickApprove={onClickApprove}
        selectedReason={selectedReason}
        setSelectedReason={setSelectedReason}
        disabled={buttonDisabled}
        loading={approveBtnLoading} />

      {/* Decline Modal */}
      <DeclineModal 
        isOpen={isOpenDecline} 
        setIsOpen={setIsOpenDecline}
        reasonItems={allSettings.discountDeclineReasons}
        onClickDecline={onClickDecline}
        selectedReason={selectedReason}
        setSelectedReason={setSelectedReason}
        disabled={buttonDisabled}
        loading={declineBtnLoading} />

    </Fragment>
  );
}

export default withReducer([{ partnerPromotion: partnerPromotionReducer }])(PartnersPromotions);
